import { forwardRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import Header from "../components/header";
import { Rocket, TrendingUp} from "lucide-react";
import { Dialog, DialogTrigger,DialogContent, DialogHeader, DialogTitle,DialogDescription } from "@/components/ui/dialog";
import { BuyingSettings } from "modules/users/components/buying-settings";


import { useMediaQuery } from "@/hooks/use-media-query";
import { CarriSteps } from "../components/steps";

import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

import { Testimonials } from "../components/testimonials";

import {Avatar, AvatarImage} from '@/components/ui/avatar';
import { Link, useNavigate } from "react-router-dom";
import SimpleHeader from "../components/simple-header";



export const LandingPage = () => {
    const navigate = useNavigate();
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const isVisitor = localStorage.getItem("visitor");
    
    useEffect(() => {
        if (isVisitor) {
            console.log("Navigating to /store for first-time visitor");
            navigate("/store");
        }
    }, [isVisitor, navigate]);


   
    return (
    (isVisitor)?(
        <></>
    ):
    <>
    <SimpleHeader/>
    <main className="noto-sans-regular bg-slatew-16 h-16-50">
        <div className={cn("flex flex-col w-full bg-[#FEEDE1] min-h-[95dvh] ",
            {
                "py-14 px-12 gap-8":isDesktop,
                "pt-8 px-4 pb-5":!isDesktop
            })}>
            <div className="w-full flex flex-row flex-wrap lg:flex-nowrap  text-sm lg:text-base items-center">
                <div className={cn("flex flex-col",
                    {
                        "pl-24 w-[50%] gap-4":isDesktop,
                        "w-full gap-8":!isDesktop
                    })}>
                    <div className="flex flex-col gap-8  w-full lg:w-[80%] flex-wrap items-center">
                        <div className="flex flex-col">
                            <p className={cn("text-3xl xl:text-5xl font-extrabold",{
                                "text-left":isDesktop,
                                "text-center":!isDesktop
                            })} >
                                Con <span className="russo-one-regular font-semibold  text-brand">Carriapp</span>, tu compra del mes al mejor precio posible.
                            </p>                                         
                        </div>
                    </div>
                    <div className="flex flex-col gap-2 montserrat w-full lg:w-[80%] text-left">
                        <p className="text-base font-semibold">
                            Armas tu lista, <span className="font-bold">te indicamos si te conviene comprar todo en una sola tienda o combinar las ofertas de varias</span><span className="text-primary font-bold"> y armamos tu carrito.</span> Calculamos considerando membresías y costos de despacho. Para que tu ahorro sea real.
                        </p>
                    </div>
                    <div className={cn("flex flex-col w-full items-start justify-center mt-0 gap-4",
                        {
                            "items-center":!isDesktop,
                        })}>
                        
                        <p>Consideramos <span className="font-semibold">precios, promociones, membresias y costos de despacho</span> de las siguientes tiendas:</p>
                        <div className="flex flex-row flex-wrap justify-center items-center gap-8 ml-2">
                            <Avatar className={cn("opacity-40 hover:opacity-100 transition-opacity duration-100 w-12 h-12",{
                                "":isDesktop,
                                "w-12 h-13":!isDesktop
                            })}>
                                <AvatarImage src="https://storage.googleapis.com/carry_images/lider_logo_circle.png"/>
                            </Avatar>
                            <Avatar className={cn("opacity-40 hover:opacity-100 transition-opacity duration-100 w-12 h-12",{
                                "":isDesktop,
                                "w-12 h-13":!isDesktop
                            })}>
                                <AvatarImage src="https://storage.googleapis.com/carry_images/tottus_circle.png"/>
                            </Avatar>
                            <Avatar className={cn("opacity-40 hover:opacity-100 transition-opacity duration-100 w-12 h-12",{
                                "":isDesktop,
                                "w-12 h-13":!isDesktop
                            })}>
                                <AvatarImage src="https://storage.googleapis.com/carry_images/unimarc_logo.png"/>
                            </Avatar>                    
                            <Avatar className={cn("opacity-40 hover:opacity-100 transition-opacity duration-100 w-12 h-12",{
                                "":isDesktop,
                                "w-12 h-13":!isDesktop
                            })}>
                                <AvatarImage src="https://storage.googleapis.com/carry_images/jumbo_logo_circle.png"/>
                            </Avatar>
                            
                        </div>            
                    </div>                     
                    <div className={cn("flex flex-row justify-left items-center flex-wrap",{
                        "justify-start gap-16 mt-5":isDesktop,
                        "justify-center gap-8":!isDesktop
                        })}>
                        <Link to="/onboarding">
                        <Button className="h-16 text-xl font-semibold" variant="default" size={"lg"}>
                            <Rocket  className="!w-8 !h-8"/> ¡Comienza a ahorrar!</Button>
                        </Link>                                 
                    </div>
                    <div className={cn("flex flex-row gap-2 h-14 my-0",{
                        "my-4":isDesktop,
                        "mx-auto":!isDesktop
                    })}>
                        <div className="flex flex-col items-center">
                            <span className="text-xl font-bold">+20%</span>
                            Ahorro Promedio
                        </div>
                        <Separator orientation="vertical" className="bg-foreground/20 mx-4" />
                        <div className="flex flex-col items-center">
                            <span className="text-xl font-bold">+60.000</span>
                            productos
                        </div>            
                        <Separator orientation="vertical" className="bg-foreground/20 mx-4" />
                        <div className="flex flex-col items-center">
                            <span className="text-xl font-bold flex gap-2">+15000 <TrendingUp className="w-4 best-price"/></span>
                            usuarios
                        </div>                              
                    </div>
                    <div className={cn("flex flex-col gap-3",!isDesktop&&"items-center")}>
                        <p className={cn("font-semibold",{
                            "text-center":!isDesktop,
                        })}>Respaldado por: </p> 
                        <div className={cn("flex flex-row items-center gap-2 h-10 flex-wrap")}>
                            <a href="https://startupchile.org/blog/estas-son-las-startups-seleccionadas-para-big-10/" target="_blank" rel="noopener noreferrer"><img className={cn(isDesktop?"h-8":"h-5")} src="https://storage.googleapis.com/carry_images/StartUpChile_Color.png" alt="Corfo Logo"/></a>    
                            <Separator orientation="vertical" className="bg-foreground/20 mx-4" />
                            <img className={cn(isDesktop?"h-8":"h-5")} src="https://storage.googleapis.com/carry_images/Google_for_Startups_logo.svg.png" alt="Google Logo"/>
                        </div>
                    </div>
                </div>
                <div className="w-full flex-1 ">
                    <img src="https://storage.googleapis.com/carry_images/main_landing.webp" alt="Carriapp" className="w-full h-auto"/>
                </div>            
            </div>   
        </div>
        <div className="flex flex-col w-full 2xl:w-[80%] mx-auto px-4 mt-8  gap-4">               
            <CarriSteps />
            
        
            <Separator className="my-4" />
            <h2 className={cn("russo-one-regular font-semibold text-primary",{"text-2xl text-center":isDesktop," text-lg":!isDesktop})}
                >Lo que dicen nuestros usuarios.</h2>
            <Testimonials />
            <Separator className="my-4" />
            {/* <OrderExampleDetail store_resume={store_resume} workingCart={workingCart} loading={false} />               */}
        </div>
    </main>    
    </>);
}




export const StarDialog = forwardRef<HTMLDivElement>((props,ref) => {
    return(
        <Dialog>
        <DialogTrigger asChild>
            <Button variant="default" className="font-semibold">¡Comencemos!</Button>                            
        </DialogTrigger>
        <DialogContent className="text-xs gap-2 md:gap-4">
            <DialogHeader>
                <DialogTitle className="">Ajustes Iniciales</DialogTitle>
                <DialogDescription>Unos rápidos ajustes para optimizar tús compras.</DialogDescription>
            </DialogHeader>
            <BuyingSettings  
                    className="text-xs mt-0"
            />
        </DialogContent>
    </Dialog>            
    );
});



